'use strict';
var React = require('react');
var ReactDOM = require('react-dom');
var Animation = require('simple-animation');

var Page = require('./Page/Page.jsx');
var optimizeCall = require('../helper/optimizeCall');

var MainStage = React.createClass({
  propTypes: {
    size: React.PropTypes.shape({
      width: React.PropTypes.number,
      height: React.PropTypes.number
    }).isRequired,
    domSize: React.PropTypes.shape({
      width: React.PropTypes.number,
      height: React.PropTypes.number
    }),
    current: React.PropTypes.object,
    target: React.PropTypes.object,
    animation: React.PropTypes.object,
    showComments: React.PropTypes.bool.isRequired,
    canFix: React.PropTypes.bool.isRequired,
    orientation: React.PropTypes.string,
    onRedirectTo: React.PropTypes.func.isRequired,
    onOpenPage: React.PropTypes.func.isRequired,
    onPageScroll: React.PropTypes.func,
    onShowRemark: React.PropTypes.func.isRequired,
    pageNeedRerender: React.PropTypes.bool.isRequired
  },

  componentDidMount: function () {
    this.scrollCall = optimizeCall();
    this.scrollCall.add(this._callScroll);
  },

  shouldComponentUpdate: function (nextProps) {
    return !this.isScrolling && nextProps.pageNeedRerender; // 如果正在滚动, 禁止重新渲染
  },

  componentWillUnmount: function () {
    clearTimeout(this.scrollingTimer); // 在 unmount 之前一定要清理掉 timer
  },

  componentDidUpdate: function () {
    var current = this.props.current;
    var target = this.props.target;
    var animation = this.props.animation;
    var _this = this;
    if (this.props.target) {
      if (animation && animation.name) {
        new Animation({
          stage: ReactDOM.findDOMNode(this.refs.stage),
          one: ReactDOM.findDOMNode(this.refs[current.ID]),
          two: ReactDOM.findDOMNode(this.refs[target.ID]),
          onStart: function () {
            // console.log('start animating');
          },
          onEnd: function () {
            _this.props.onOpenPage(target.ID);
          }
        }).animate(animation.name, animation.duration, animation.timing);
      } else {
        _this.props.onOpenPage(target.ID);
      }
    }
  },
  render: function () {
    var position = this.props.position || {x: 0, y: 0};
    var style = {
      left: position.x,
      top: position.y,
      width: this.props.size.width,
      height: this.props.size.height
    };
    var current = this.props.current;
    var target = this.props.target;
    var pageList = [];
    var size = this.props.size;
    if (current) {
      pageList.push(
        <li className="page-list-item"
            style={{zIndex: 1}}
            key={current.ID}
            ref={current.ID}>
          <Page page={current}
                size={size}
                isLoaded={!target}
                domSize={this.props.domSize}
                canFix={this.props.canFix}
                appOrientation={this.props.orientation}
                onLinkClick={this._onLinkClick}
                onShowRemark={this.props.onShowRemark}
                alwaysShowLinks={this.props.alwaysShowLinks}
          />
        </li>
      );
    }
    if (target) {
      pageList.push(
        <li className="page-list-item"
            style={{zIndex: 2}}
            key={target.ID}
            ref={target.ID}>
          <Page page={target}
                size={size}
                domSize={this.props.domSize}
                canFix={this.props.canFix}
                appOrientation={this.props.orientation}
                onLinkClick={this._onLinkClick}
                onShowRemark={this.props.onShowRemark}
          />
        </li>
      );
    }
    return (
      <div className="stage-container animation-stage-container main-stage-container" style={style}>
        <ul ref="stage"
            className='stage'
            onScroll={this.props.showComments && this._onScroll}>
          {pageList}
        </ul>
      </div>
    );
  },
  _onLinkClick: function (targetID, animation) {
    if (targetID === 'command:back') { // 直接打开前个页面
      this.props.onOpenPage(targetID);
      return;
    }
    this.props.onRedirectTo(targetID, animation);
  },
  _onScroll: function (e) {
    this.scrollCall.call(e);
  },
  _callScroll: function (e) {
    var self = this;
    this.isScrolling = true;
    clearTimeout(this.scrollingTimer);
    this.scrollingTimer = setTimeout(function () {
      self.isScrolling = false;
    }, 200); // 200ms 内不允许 rerender
    if (this.props.onPageScroll) {
      this.props.onPageScroll(e.target.scrollTop);
    }
  }
});

module.exports = MainStage;



// WEBPACK FOOTER //
// ./src/views/MainStage.jsx